import { useEffect, useState } from "react";
import { getTypes, postContactUs } from "../helpers/contactUs.helper";
import { notification } from "antd";

const useContactUs = (t) => {
  const [formData, setFormData] = useState({});
  const [validated, setValidated] = useState(false);
  const [typesSelect, setTypesSelect] = useState([]);

  useEffect(() => {
    (() => {
      getTypesContactUs();
    })();
  }, []);

  const getTypesContactUs = async () => {
    const language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "ES";
    const res = await getTypes(language);
    setTypesSelect(res);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: msg,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() !== false) {
      const language = localStorage.getItem("language")
        ? localStorage.getItem("language").toUpperCase()
        : "ES";
      const request = {
        typeId: 8, //formData.typeId,
        name: formData.name,
        lastName: formData.lastName,
        email: formData.email,
        countryPhoneCode: "COL",
        phone: formData.phone,
        description: formData.description,
        countryCode: "COL",
        language,
        accepts: true,
      };
      const res = await postContactUs(request);
      if (res.success) {
        openNotificationWithIcon("success", t("contact.messageSent"));
        form.reset();
        setValidated(false);
      } else {
        setValidated(true);
        openNotificationWithIcon("error", t("contact.messageError"));
      }
    } else {
      setValidated(true);
    }
  };

  return {
    handleChange,
    handleSubmit,
    validated,
    typesSelect,
    formData,
  };
};

export default useContactUs;
